// @flow

import { setConfig } from "react-hot-loader"

setConfig({
  pureSFC: true,
  ignoreSFC: true,
  pureRender: true
})
